import {
  NotFoundScreenWrapper,
  NotFoundSubtitle,
  NotFoundTitle,
} from './styles';

export default function NotFound() {
  return (
    <NotFoundScreenWrapper>
      <NotFoundSubtitle>No data to display</NotFoundSubtitle>
    </NotFoundScreenWrapper>
  );
}
